export default {
  report: 'Reporte',
  build: 'Build',
  buildAndReport: 'Build y reporte',
  mixed: 'Varios ngtorch',
  kindBranch: 'rama',
  kindCommit: 'commit',
  plans: '{count} plan | {count} planes',
  reinstall: 'Con reinstalación de metadatos del paquete',
  frozenAt: 'Resuelto el {date}',
  withoutOverride: '{count} plan con el ngtorch de la imagen | {count} planes con el ngtorch de la imagen'
}
